import { render, staticRenderFns } from "./shop-request-checkin.vue?vue&type=template&id=08f08497&"
import script from "./shop-request-checkin.vue?vue&type=script&lang=js&"
export * from "./shop-request-checkin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports